export * from './SponsoredIcon';
